import React, { useState, useEffect, useRef } from 'react';
import NotificationPanels from '../NotificationPanels';
import ClientHeader from '../Partials/ClientHeader';
import ClientSideBar from '../Partials/ClientSideBar';
import Header from '../Header';
import Sidebar from '../Sidebar';
import CandidateTab from '../CandidateTab';
import Footer from '../Footer';
// import { useDispatch, useSelector} from 'react-redux';
// import { getCourtRecordCheckDeclarationDetails } from '../../Actions/courtRecordCheckDeclarationAction';
// import MainFormCourtRecordCheckDeclaration from './MainFormCourtRecordCheckDeclaration';
import { useDispatch } from 'react-redux';
import { getCourtRecordCheckData } from '../../Actions/CourtRecordCheckActions';
import Loader from '../Common/loader';
import { getForm16CheckData } from '../../Actions/form16Actions';
import MainFormForm16 from './MainFormForm16';
import ProgressHeading from '../Common/ProgressHeading';


const Form16 = () => {
    const dispatch = useDispatch();
    const form = useRef();
    const [role, setRole] = useState();
    const [formData, setFormData] = useState({});
    const [allCheckData, setAllCheckData] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const [uploadRecord, setUploadRecord] = useState({});

    const [uploadedFilesCount, setUploadedFilesCount] = useState({});
    const [documnetMandatory, setDocumnetMandatory] = useState({});
    // const [courtRecordCheckDeclaration, setCourtRecordCheckDeclaration] = useState({});
    // const dispatch = useDispatch();
    useEffect(() => {
        const fetchData = async () => {
            setIsLoading(true);
            // dispatch(getCourtRecordCheckDeclarationDetails());
            dispatch(getForm16CheckData(getDataCallback));
            console.log("fetched")
        }
        fetchData();
    }, []);

    const getDataCallback = (data) => {
        console.log(data);
        setFormData(data?.data);
        setAllCheckData(data?.data?.checksDetails)
        setIsLoading(false);

        

        // setUploadRecord()

        getUploadedFilesCount(data?.data?.checksDetails);
        getDocumentIdMandatory(data?.data?.checksDetails);
    }

    const reRenderAgain = (value, index) => {

        // setUnsavedAddData(value);
        // dispatch(getAddress());
        // dispatch(getForm16CheckData(getDataCallback));
        

        let newCheckDetails = {...allCheckData};

        let uploadRes = {...value}

        let obj = {};
        let allUploadDocs = [];

        let rqDocs = newCheckDetails[index-1]?.required_documents?.[0];

        // value?.map((item) => {
        //     obj.preview_key = item?.preview_key;
        //     obj.document_id = rqDocs?.doc_master_id;
        //     obj.case_check_id = newCheckDetails[index-1]?.case_check_id;
        //     obj.id = item?.document_id;
        //     obj.case_id = formData?.initial_case_id;
        //     obj.master_docid = rqDocs?.doc_master_id;
        //     obj.candidate_id = formData?.candidates?.id;
        //     allUploadDocs.push(obj);
        // })

        // uploadDocsObj = 

        // newCheckDetails[index].uploaded_documents = allUploadDocs;

        // if(value){
        //     setUploadedFilesCount((prev) => ({
        //         ...prev,
        //         [rqDocs?.id] : Object?.values(value).length
        //     }));
        // }
        //     getDocumentIdMandatory(newCheckDetails);

        // // setAllCheckData(newCheckDetails);



        // setUploadRecord({ caseCheckId : newCheckDetails[index-1]?.case_check_id, docId : rqDocs?.id})
      }

      const reRenderAgain2 = (value, index, doc_count) => {
        let newCheckDetails = {...allCheckData};

        let uploadRes = {...value}

        let obj = {};
        let allUploadDocs = [];

        let rqDocs = newCheckDetails[index-1]?.required_documents?.[0];

        newCheckDetails[index-1].uploaded_documents = allUploadDocs;

        if(value && !doc_count){
            setUploadedFilesCount((prev) => ({
                ...prev,
                [index-1] : {[rqDocs?.id] : Object?.values(value).length}
            }));
        }else if(doc_count){
          setUploadedFilesCount((prev) => ({
            ...prev,
            [index-1] : {[rqDocs?.id] : doc_count}
        }));
        }
            getDocumentIdMandatory(newCheckDetails);

        // setAllCheckData(newCheckDetails);



        setUploadRecord({ caseCheckId : newCheckDetails[index-1]?.case_check_id, docId : rqDocs?.id})
      }  

      const getUploadedFilesCount = (checksDetails) => {
        let uploadedFilesCount = {};
        for (let i in checksDetails) {
          let obj = {};
          for (let j in checksDetails[i].required_documents) {
            let count = 0;
            for (let k in checksDetails[i].uploaded_documents) {
              if (
                checksDetails[i].uploaded_documents[k].document_id ==
                checksDetails[i].required_documents[j].id
              ) {
                count++;
              }
            }
            obj[`${checksDetails[i].required_documents[j].id}`] = count;
          }
          uploadedFilesCount[i] = obj;
        }
        setUploadedFilesCount(uploadedFilesCount);
      };
      // alert(JSON.stringify(uploadedFilesCount));
    
      const getDocumentIdMandatory = (checksDetails) => {
        let uploadedFilesCount = {};
        for (let i in checksDetails) {
          let obj = {};
          for (let j in checksDetails[i].required_documents) {
            obj[
              `${checksDetails[i].required_documents[j].id}`
            ] = `${checksDetails[i].required_documents[j].is_mandatory}`;
          }
          uploadedFilesCount[i] = obj;
        }
    
        // alert(JSON.stringify(uploadedFilesCount));
        setDocumnetMandatory(uploadedFilesCount);
      };  
      

    return (
        <>
            {/* {isLoading && <Loader />} */}
            <NotificationPanels />
            {role === "EP" ? <ClientHeader /> : <Header />}
            {role === "EP" ? <ClientSideBar /> : <Sidebar />}
            <section className="main-section candidate-tab-form" style={{ paddingTop: '60px' }}>
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-auto w-100-mbl bg-gray-mbl">
                            <ProgressHeading/>
                            <CandidateTab activeTab={"Form 16"} />
                        </div>
                        <div className="col bg-gray-mbl">
                            {/*Form*/}
                            <form ref={form} className="p-3 form2 form-section" style={{height: 'auto'}}>
                                <MainFormForm16 formData={formData} CandidateDetails={formData?.formData} allCheckData={allCheckData} 
                                reRenderAgain={reRenderAgain} 
                                uploadedFilesCount={uploadedFilesCount}
                                documnetMandatory={documnetMandatory}
                                uploadRecord={uploadRecord}
                                reRenderAgain2={reRenderAgain2}
                                getDataCallback={getDataCallback}
                                />
                                {/* <MainFormCourtRecordCheckDeclaration formData={formData} CandidateDetails={formData?.formData}/> */}
                            </form>

                            <Footer />
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default Form16